import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SettingsErrorState({
  message = 'Impossibile caricare le impostazioni.',
  onRetry,
  testId = 'settings-error',
}) {
  return (
    <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-800" role="alert" data-testid={testId}>
      <div className="flex items-start gap-2">
        <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <div className="min-w-0 flex-1">
          <div>{message}</div>
          {onRetry && (
            <Button type="button" size="sm" variant="outline" className="mt-3 border-red-200 text-red-800 hover:bg-red-100" onClick={onRetry}>
              <RefreshCw className="mr-1.5 h-3.5 w-3.5" aria-hidden="true" /> Riprova
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}